import React from 'react';

import { GlyphProps, Size } from '@atlaskit/icon/types';

import {
  TestTypeColorName,
  TestTypeIconName,
} from '@qality/common-model/src/TestType';
import { TEST_TYPE_ICONS } from '@qality/common-utils/src/TestType.const';

import TestTypeColorUtil from './TestTypeColor.util';

type IconAppearance = 'subtle' | 'bold' | 'subtlest';

interface GenericIconProps extends GlyphProps {
  iconName: TestTypeIconName;
  colorName: TestTypeColorName;
  appearance?: IconAppearance;
  iconSize?: Size;
}

export default function TestTypeIcon({
  iconName,
  colorName,
  appearance = 'subtle',
  iconSize = 'small',
  ...restProps
}: GenericIconProps): JSX.Element {
  const IconComponent: React.ElementType =
    TEST_TYPE_ICONS.get(iconName).component;

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      testId='test-type-icon'
      primaryColor={TestTypeColorUtil.getTextColor(appearance, colorName)}
      iconSize={iconSize}
      {...restProps}
    />
  );
}
